import { Code, ConnectError } from "@bufbuild/connect";
import { EventRoleAuthorizationError } from "@spwn-portal/grpc";

type EventDashboardPermissionErrorResolution =
  | "none"
  | "redirect"
  | "alternative-event-authorized";

export const isEventDashboardPermissionError = (
  error: unknown
): error is ConnectError =>
  error instanceof ConnectError &&
  (error.code === Code.PermissionDenied || error.code === Code.Unauthenticated);

export const getEventDashboardPermissionErrorResolution = (
  errors: unknown[]
): EventDashboardPermissionErrorResolution => {
  const permissionErrors = errors.filter(isEventDashboardPermissionError);

  if (permissionErrors.length === 0) {
    return "none";
  }

  const hasAlternativeEventAuthorization = permissionErrors.some(
    (error) => error.findDetails(EventRoleAuthorizationError).length > 0
  );

  return hasAlternativeEventAuthorization
    ? "alternative-event-authorized"
    : "redirect";
};

/**
 * 複数のAPIで1画面を構成するダッシュボード向けの判定。
 * どのAPIも同じ条件で認可されるので、権限がなければ全てのAPIが失敗する。
 * 取得中または成功したAPIが残っている間は画面全体を切り替えず、
 * 個別の失敗は各セクションのエラー表示に任せる。
 */
export const getEventDashboardPermissionErrorResolutionForAllRequests = (
  errors: unknown[]
): EventDashboardPermissionErrorResolution => {
  const hasRequestWithoutError = errors.some(
    (error) => error === undefined || error === null
  );

  return hasRequestWithoutError
    ? "none"
    : getEventDashboardPermissionErrorResolution(errors);
};
